import React from 'react';
import cx from "classnames";
import { Link } from 'react-router-dom';

import ItemDate from "./ItemDate.jsx";
import ImageAsync from '../ImageAsync.jsx';
import { Badge } from "@/components/ui/badge";

import "../../styles/Item.css";


export const ItemHeader = React.memo(function ItemHeader({ item, to, back, className, onClick = () => null, onBackClick = () => null }) {
    const location = item.mainLocation ? item.mainLocation : item.locations[0];
    const title = 'highlight' in item ? item.highlight.title || item.title : item.title;
    const companyName = item.company ? item.company.name : null;

    const El = (
        <div className={cx("ItemHeader", className)} onClick={() => onClick(item)} to={to}>
            {item.logo && <ImageAsync src={item.logo} />}

            <h1 dangerouslySetInnerHTML={{ __html: title }} />

            {companyName && <h2 dangerouslySetInnerHTML={{ __html: companyName }} />}

            <h3>
                <span className="category">{item.category.name}</span>
                <span className="kind">{item.kind}</span>
            </h3>

            <div className="address">
                <i className="fa fa-building-o"></i>
                {location.address}
            </div>

            <div className="attrs">
                {item.remote && <Badge variant="outline" className="ml-1 border-cyan text-cyan text-[11px] font-normal">Remote</Badge>}
                {item.visa && <Badge variant="outline" className="ml-1 border-cyan text-cyan text-[11px] font-normal">Visa</Badge>}
            </div>

            <ItemDate date={item.time} />
            <div className="back">
                {back &&
                    <Link to={back} onClick={onBackClick}>
                        <i className="fa fa-chevron-left"></i>
                    </Link>}
            </div>
        </div>
    );

    if (to) {
        return <Link className="no-underline hover:text-inherit visited:text-inherit" to={to}>{El}</Link>;
    }
    return El;
}, (prevProps, nextProps) => {
    // Only re-render when mainLocation address changes
    const current = prevProps.item.mainLocation;
    const next = nextProps.item.mainLocation;
    if (!(next && current)) return true;
    return next.address === current.address;
});


export function ItemDescription({ item }) {
    const description = 'highlight' in item ? item.highlight.description || item.description : item.description;
    return (
        <div className="ItemDescription">
            <div dangerouslySetInnerHTML={{ __html: description }} />
            {item.apply &&
                <div className="howto-apply">
                    <h2>how to apply</h2>
                    <div dangerouslySetInnerHTML={{ __html: item.apply }} />
                </div>
            }
        </div>
    );
}



export function ItemFooter({ item }) {
    return (
        <div className="bg-white px-[18px] py-[18px] flex items-center shrink-0">
            {(!item.apply && item.source) &&
                <a target="_blank" rel="nofollow noreferrer noopener" href={item.source}
                    className="w-full flex items-center justify-center border-2 border-cyan text-[#3f3861] hover:bg-cyan hover:text-white font-semibold tracking-widest text-sm h-11 rounded-[var(--radius-lg)] no-underline transition-colors">
                    APPLY NOW ↗
                </a>
            }
        </div>
    );
}
